import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const pricePackageService = {
  async get(categoryId: number, summaryId: string): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_PACKAGE_PRICE
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', '' + summaryId),
          config
        );
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
}
